import type { TutorialStep } from "./tutorialStepTypes";

export const combatBasicsInfo: TutorialStep = {
  id: "combat-basics-info",
  dismissible: true,
  buildKind: null,
  enableEndTurn: false,
  prompt: () => ({
    title: "Combat basics",
    body: "HP is shown on a 1-10 scale. A 7 HP unit deals 70% damage and captures at 70% strength. Terrain also cuts incoming damage (plains 5%, barracks 20%).",
    highlight: null,
    dismissible: true,
  }),
  allowsTile: () => false,
  isComplete: () => false,
};
